import React, { useEffect } from "react";
import { Spinner, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm, FieldArray } from "formik";
import {
  SubPageTemplateListQueryResult,
  useDeleteTemplateSubPageMutation,
  useSubPageTemplateListQuery,
} from "../../graphql/subpage.hooks";

interface IFormValues {
  templates: NonNullable<
    SubPageTemplateListQueryResult["data"]["subPageTemplateList"]
  >[number][];
}

export const SubpageTemplates = () => {
  const navigate = useNavigate();

  const { data, loading, refetch } = useSubPageTemplateListQuery();
  const [deleteTemplate, { loading: deletingLoading }] =
    useDeleteTemplateSubPageMutation();

  useEffect(() => {
    document.title = "Subpage Templates";
  }, []);

  const moveToCreateForm = () => {
    navigate("/subpage-templates/create");
  };

  const tryDeleteTemplate = async (templateId: number) => {
    try {
      const { data } = await deleteTemplate({
        variables: { id: templateId },
      });

      if (data?.deleteTemplateSubPage) {
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const initialValues: IFormValues = {
    templates: data.subPageTemplateList.map(({ id, name, position, page }) => ({
      id,
      name,
      position: position || 0,
      page: {
        id: page.id,
      },
    })),
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Subpage Templates</h1>
        </div>
      </div>

      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <Formik
          initialValues={initialValues}
          onSubmit={() => {}}
          enableReinitialize
        >
          {({ values }) => (
            <FormikForm className="w-100">
              <table className="col-11 mb-5 m-auto">
                <thead>
                  <tr>
                    <th
                      className="d-none d-md-table-cell"
                      style={{ width: 100 }}
                    >
                      Id
                    </th>
                    <th
                      className="d-none d-md-table-cell"
                      style={{ width: 100 }}
                    >
                      PageId
                    </th>
                    <th>Title</th>
                    <th className="text-center">Order</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <FieldArray name="categories">
                    {() =>
                      values.templates.map(({ id, name, position, page }) => {
                        return (
                          <tr key={id} style={{ lineHeight: "2.5" }}>
                            <td className="d-none d-md-table-cell">{id}</td>
                            <td style={{ width: 100 }}>{page.id}</td>
                            <td style={{ width: 100 }}>{name}</td>
                            <td className="text-center" style={{ width: 100 }}>
                              {position}
                            </td>
                            <td
                              className="text-center px-5"
                              style={{ width: 250 }}
                            >
                              <Link
                                to={`/subpage-templates/${id}/edit`}
                                className="btn btn-outline-primary text-primary primary-hover col-5 me-2"
                              >
                                Edit
                              </Link>
                              <Button
                                variant="outline-danger"
                                className="text-danger danger-hover col-5"
                                onClick={() => tryDeleteTemplate(id)}
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </FieldArray>
                  {!data.subPageTemplateList.length && (
                    <tr>
                      <td
                        colSpan={5}
                        className="text-center"
                        style={{ height: "200px" }}
                      >
                        No Subpage Templates Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="d-flex justify-content-center col-11 col-md-8 m-auto">
                <button
                  type="button"
                  onClick={moveToCreateForm}
                  disabled={loading || deletingLoading}
                  className="btn btn-primary text-white col-12 col-md-4 mb-2 mb-md-0"
                >
                  Create New Template
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};
